export type Batch50Seed = {
  personId: string
  name: string
  firstShow: string
  firstSeason: number
  firstPartner: string | null
  billedFrom: string | null
  seasons: { show: string; season: number }[]
  sourceUrl: string
  relationships: {
    id: string
    displayName: string
    firstShow: string | null
    firstSeason: number | null
    firstYear: number | null
    sourceUrl: string | null
    partners: { personId: string; name: string }[]
    appearances: { show: string; season: number }[]
  }[]
}

// Batch selected on 2026-09-30: connected fan favorites plus recent-season cast.
// Facts below come from Journey90's indexed catalog; profile prose is assembled in castBatch50.ts.
export const batch50Seeds = [
  {
    "personId": "p-patrick-mendes",
    "name": "Patrick Mendes",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 9,
    "firstPartner": "Thaís",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 9
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/season-3-couples-bios",
    "relationships": [
      {
        "id": "ARC-B15A1B3EFFC7",
        "displayName": "Patrick & Thaís",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 9,
        "firstYear": 2022,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-thais-ramone",
            "name": "Thaís"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 9
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 8
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-pedro-jimeno",
    "name": "Pedro Jimeno",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 4,
    "firstPartner": "Chantel",
    "billedFrom": "Dominican Republic",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 4
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 4
      },
      {
        "show": "90 Day: The Single Life",
        "season": 5
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/season-5-90-day-singles-bios-updates",
    "relationships": [
      {
        "id": "ARC-35AAB4B45C12",
        "displayName": "Chantel & Pedro",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 4,
        "firstYear": 2016,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-chantel-everett",
            "name": "Chantel"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 4
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 4
          }
        ]
      },
      {
        "id": "ARC-06EDA993968C",
        "displayName": "Sophie & Pedro",
        "firstShow": "90 Day: The Single Life",
        "firstSeason": 5,
        "firstYear": 2026,
        "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/90-day-the-single-life-season-5-drama-episodes-recap",
        "partners": [
          {
            "personId": "p-sophie-sierra",
            "name": "Sophie"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: The Single Life",
            "season": 5
          }
        ]
      }
    ]
  },
  {
    "personId": "p-liz-woods",
    "name": "Liz Woods",
    "firstShow": "90 Day: The Single Life",
    "firstSeason": 1,
    "firstPartner": "Ed",
    "billedFrom": "Unknown",
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 7
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8
      },
      {
        "show": "90 Day: The Single Life",
        "season": 5
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life",
    "relationships": [
      {
        "id": "ARC-257C9F77A6EF",
        "displayName": "Big Ed & Liz",
        "firstShow": "90 Day: The Single Life",
        "firstSeason": 1,
        "firstYear": 2021,
        "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-Day-Fiance-The-Last-Resort-Couples-Bios",
        "partners": [
          {
            "personId": "p-ed-brown",
            "name": "Big Ed"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 8
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 1
          },
          {
            "show": "90 Day: The Single Life",
            "season": 1
          }
        ]
      }
    ]
  },
  {
    "personId": "p-rosemarie-vega",
    "name": "Rosemarie Vega",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 4,
    "firstPartner": "Ed",
    "billedFrom": "Philippines",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 4
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days",
    "relationships": [
      {
        "id": "ARC-7966A39D3E56",
        "displayName": "Big Ed & Rose",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 4,
        "firstYear": 2020,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-ed-brown",
            "name": "Big Ed"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 4
          }
        ]
      }
    ]
  },
  {
    "personId": "p-zied-hakimi",
    "name": "Zied Hakimi",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 3,
    "firstPartner": "Rebecca",
    "billedFrom": "Tunisia",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 3
      },
      {
        "show": "90 Day Fiancé",
        "season": 8
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/season-3-couples-bios",
    "relationships": [
      {
        "id": "ARC-3A90E6C05154",
        "displayName": "Rebecca & Zied",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 3,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-rebecca-parrott",
            "name": "Rebecca"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 3
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-loren-goldstone",
    "name": "Loren Brovarnik",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 3,
    "firstPartner": "Alexei",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 9
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-556C27E5319A",
        "displayName": "Loren & Alexei",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 3,
        "firstYear": 2015,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-alexei-brovarnik",
            "name": "Alexei"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 1
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 9
          }
        ]
      }
    ]
  },
  {
    "personId": "p-alexei-brovarnik",
    "name": "Alexei Brovarnik",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 3,
    "firstPartner": "Loren",
    "billedFrom": "Israel",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 9
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-556C27E5319A",
        "displayName": "Loren & Alexei",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 3,
        "firstYear": 2015,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-loren-goldstone",
            "name": "Loren"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 1
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 9
          }
        ]
      }
    ]
  },
  {
    "personId": "p-kenneth-niedermeier",
    "name": "Kenneth Niedermeier",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 2,
    "firstPartner": "Armando",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 8
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-8-couples-bios",
    "relationships": [
      {
        "id": "ARC-7DD923A1934C",
        "displayName": "Kenneth & Armando",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 2,
        "firstYear": 2020,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-armando-rubio",
            "name": "Armando"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 8
          }
        ]
      }
    ]
  },
  {
    "personId": "p-armando-rubio",
    "name": "Armando Rubio",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 2,
    "firstPartner": "Kenneth",
    "billedFrom": "Mexico",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 8
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-8-couples-bios",
    "relationships": [
      {
        "id": "ARC-7DD923A1934C",
        "displayName": "Kenneth & Armando",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 2,
        "firstYear": 2020,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-kenneth-niedermeier",
            "name": "Kenneth"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 8
          }
        ]
      }
    ]
  },
  {
    "personId": "p-jenny-slatten",
    "name": "Jenny Slatten",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 1,
    "firstPartner": "Sumit",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios",
    "relationships": [
      {
        "id": "ARC-3E94B8CA8362",
        "displayName": "Jenny & Sumit",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 1,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-sumit-singh",
            "name": "Sumit"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 1
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 7
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-sumit-singh",
    "name": "Sumit Singh",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 1,
    "firstPartner": "Jenny",
    "billedFrom": "India",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios",
    "relationships": [
      {
        "id": "ARC-3E94B8CA8362",
        "displayName": "Jenny & Sumit",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 1,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-jenny-slatten",
            "name": "Jenny"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 1
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 2
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 7
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-kalani-faagata",
    "name": "Kalani Faagata",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 6,
    "firstPartner": "Asuelu",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 6
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 1
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-Day-Fiance-The-Last-Resort-Couples-Bios",
    "relationships": [
      {
        "id": "ARC-1717419EA359",
        "displayName": "Kalani & Asuelu",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 6,
        "firstYear": 2018,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-asuelu-pulaa",
            "name": "Asuelu"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 6
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 1
          }
        ]
      }
    ]
  },
  {
    "personId": "p-asuelu-pulaa",
    "name": "Asuelu Pulaa",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 6,
    "firstPartner": "Kalani",
    "billedFrom": "Samoa",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 6
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 1
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-Day-Fiance-The-Last-Resort-Couples-Bios",
    "relationships": [
      {
        "id": "ARC-1717419EA359",
        "displayName": "Kalani & Asuelu",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 6,
        "firstYear": 2018,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-kalani-faagata",
            "name": "Kalani"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 6
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 1
          }
        ]
      }
    ]
  },
  {
    "personId": "p-brandon-gibbs",
    "name": "Brandon Gibbs",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 8,
    "firstPartner": "Julia",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 8
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 9
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-day-the-last-resort-meet-the-new-couples-bios",
    "relationships": [
      {
        "id": "ARC-E5E7048107EF",
        "displayName": "Brandon & Julia",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 8,
        "firstYear": 2020,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-julia-trubkina",
            "name": "Julia"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 9
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 2
          }
        ]
      }
    ]
  },
  {
    "personId": "p-julia-trubkina",
    "name": "Julia Trubkina",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 8,
    "firstPartner": "Brandon",
    "billedFrom": "Russia",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 8
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 9
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-day-the-last-resort-meet-the-new-couples-bios",
    "relationships": [
      {
        "id": "ARC-E5E7048107EF",
        "displayName": "Brandon & Julia",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 8,
        "firstYear": 2020,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-brandon-gibbs",
            "name": "Brandon"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 9
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 2
          }
        ]
      }
    ]
  },
  {
    "personId": "p-natalie-mordovtseva",
    "name": "Natalie Mordovtseva",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 7,
    "firstPartner": "Mike",
    "billedFrom": "Ukraine",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 7
      },
      {
        "show": "90 Day Fiancé",
        "season": 8
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      },
      {
        "show": "90 Day: The Single Life",
        "season": 2
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3
      },
      {
        "show": "90 Day: The Single Life",
        "season": 4
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 2
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life",
    "relationships": [
      {
        "id": "ARC-68AB9AF6F400",
        "displayName": "Mike & Natalie",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 7,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-mike-youngquist",
            "name": "Mike"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 7
          },
          {
            "show": "90 Day Fiancé",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          }
        ]
      },
      {
        "id": "ARC-58EFC1AB2FE6",
        "displayName": "Natalie & Josh",
        "firstShow": "90 Day: The Single Life",
        "firstSeason": 2,
        "firstYear": 2021,
        "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-day-the-last-resort-meet-the-new-couples-bios",
        "partners": [
          {
            "personId": "p-josh-weinstein",
            "name": "Josh"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: The Last Resort",
            "season": 2
          },
          {
            "show": "90 Day: The Single Life",
            "season": 2
          },
          {
            "show": "90 Day: The Single Life",
            "season": 3
          },
          {
            "show": "90 Day: The Single Life",
            "season": 4
          }
        ]
      }
    ]
  },
  {
    "personId": "p-mike-youngquist",
    "name": "Mike Youngquist",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 7,
    "firstPartner": "Natalie",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 7
      },
      {
        "show": "90 Day Fiancé",
        "season": 8
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-68AB9AF6F400",
        "displayName": "Mike & Natalie",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 7,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-natalie-mordovtseva",
            "name": "Natalie"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 7
          },
          {
            "show": "90 Day Fiancé",
            "season": 8
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          }
        ]
      }
    ]
  },
  {
    "personId": "p-josh-weinstein",
    "name": "Josh Weinstein",
    "firstShow": "90 Day: The Single Life",
    "firstSeason": 2,
    "firstPartner": "Natalie",
    "billedFrom": "Unknown",
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 2
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3
      },
      {
        "show": "90 Day: The Single Life",
        "season": 4
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 2
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/look-whos-back-on-90-day-the-single-life-new-season",
    "relationships": [
      {
        "id": "ARC-58EFC1AB2FE6",
        "displayName": "Natalie & Josh",
        "firstShow": "90 Day: The Single Life",
        "firstSeason": 2,
        "firstYear": 2021,
        "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-day-the-last-resort-meet-the-new-couples-bios",
        "partners": [
          {
            "personId": "p-natalie-mordovtseva",
            "name": "Natalie"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: The Last Resort",
            "season": 2
          },
          {
            "show": "90 Day: The Single Life",
            "season": 2
          },
          {
            "show": "90 Day: The Single Life",
            "season": 3
          },
          {
            "show": "90 Day: The Single Life",
            "season": 4
          }
        ]
      }
    ]
  },
  {
    "personId": "p-tiffany-franco",
    "name": "Tiffany Franco",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 1,
    "firstPartner": "Ronald",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3
      },
      {
        "show": "90 Day: Hunt for Love",
        "season": 1
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/look-whos-back-on-90-day-the-single-life-new-season",
    "relationships": [
      {
        "id": "ARC-CAD7C35CF7DE",
        "displayName": "Tiffany & Ronald",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 1,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-ronald-smith",
            "name": "Ronald"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 1
          }
        ]
      },
      {
        "id": "ARC-126865066DE2",
        "displayName": "Tiffany & Carlo",
        "firstShow": "90 Day: Hunt for Love",
        "firstSeason": 1,
        "firstYear": 2025,
        "sourceUrl": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-drama-recap",
        "partners": [
          {
            "personId": "p-carlo-90-day-hunt-for-love-s1",
            "name": "Carlo"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: Hunt for Love",
            "season": 1
          }
        ]
      },
      {
        "id": "ARC-64DAE29CF987",
        "displayName": "Tiffany & Rocky",
        "firstShow": "90 Day: Hunt for Love",
        "firstSeason": 1,
        "firstYear": 2025,
        "sourceUrl": "https://www.tvinsider.com/swooon/gallery/90-day-hunt-for-love-season-1-couples-still-together-relationship-updates/",
        "partners": [
          {
            "personId": "p-rocky-90-day-hunt-for-love-s1",
            "name": "Rocky"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: Hunt for Love",
            "season": 1
          }
        ]
      }
    ]
  },
  {
    "personId": "p-ronald-smith",
    "name": "Ronald Smith",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 1,
    "firstPartner": "Tiffany",
    "billedFrom": "South Africa",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 6
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-the-other-way",
    "relationships": [
      {
        "id": "ARC-CAD7C35CF7DE",
        "displayName": "Tiffany & Ronald",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 1,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-tiffany-franco",
            "name": "Tiffany"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 6
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 1
          }
        ]
      }
    ]
  },
  {
    "personId": "p-tania-maduro",
    "name": "Tania Maduro",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 7,
    "firstPartner": "Syngin",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 5
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/look-whos-back-on-90-day-the-single-life-new-season",
    "relationships": [
      {
        "id": "ARC-01C37ED4C9CE",
        "displayName": "Tania & Syngin",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 7,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-syngin-colchester",
            "name": "Syngin"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 5
          }
        ]
      }
    ]
  },
  {
    "personId": "p-syngin-colchester",
    "name": "Syngin Colchester",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 7,
    "firstPartner": "Tania",
    "billedFrom": "South Africa",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 5
      },
      {
        "show": "90 Day: The Single Life",
        "season": 2
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life",
    "relationships": [
      {
        "id": "ARC-01C37ED4C9CE",
        "displayName": "Tania & Syngin",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 7,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-tania-maduro",
            "name": "Tania"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 5
          }
        ]
      }
    ]
  },
  {
    "personId": "p-darcey-silva",
    "name": "Darcey Silva",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 1,
    "firstPartner": "Jesse",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 1
      },
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 2
      },
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 3
      },
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 4
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days",
    "relationships": [
      {
        "id": "ARC-01ADFBFB9EED",
        "displayName": "Darcey & Jesse",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 1,
        "firstYear": 2017,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-jesse-meester",
            "name": "Jesse"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 1
          },
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 2
          }
        ]
      },
      {
        "id": "ARC-6726515CA184",
        "displayName": "Darcey & Tom",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 3,
        "firstYear": 2019,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-tom-brooks",
            "name": "Tom"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 3
          },
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 4
          }
        ]
      }
    ]
  },
  {
    "personId": "p-stacey-silva",
    "name": "Stacey Silva",
    "firstShow": "90 Day: The Last Resort",
    "firstSeason": 2,
    "firstPartner": "Florian",
    "billedFrom": "Unknown",
    "seasons": [
      {
        "show": "90 Day: The Last Resort",
        "season": 2
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-day-the-last-resort-meet-the-new-couples-bios",
    "relationships": [
      {
        "id": "ARC-9D1935CA31D5",
        "displayName": "Stacey & Florian",
        "firstShow": "90 Day: The Last Resort",
        "firstSeason": 2,
        "firstYear": 2024,
        "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-day-the-last-resort-meet-the-new-couples-bios",
        "partners": [
          {
            "personId": "p-florian-sukaj",
            "name": "Florian"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: The Last Resort",
            "season": 2
          }
        ]
      }
    ]
  },
  {
    "personId": "p-david-toborowsky",
    "name": "David Toborowsky",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 5,
    "firstPartner": "Annie",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-A86718B5300C",
        "displayName": "David & Annie",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 5,
        "firstYear": 2017,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-annie-suwan",
            "name": "Annie"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-annie-suwan",
    "name": "Annie Suwan",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 5,
    "firstPartner": "David",
    "billedFrom": "Thailand",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-A86718B5300C",
        "displayName": "David & Annie",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 5,
        "firstYear": 2017,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-david-toborowsky",
            "name": "David"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-kim-menzies",
    "name": "Kim Menzies",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 5,
    "firstPartner": "Usman",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 7
      },
      {
        "show": "90 Day: The Single Life",
        "season": 5
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/season-5-90-day-singles-bios-updates",
    "relationships": [
      {
        "id": "ARC-9E71243C6B93",
        "displayName": "Kim & Usman",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 5,
        "firstYear": 2021,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-usman-umar",
            "name": "Usman"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 7
          }
        ]
      }
    ]
  },
  {
    "personId": "p-usman-umar",
    "name": "Usman Umar",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 4,
    "firstPartner": "Lisa",
    "billedFrom": "Nigeria",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 4
      },
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 7
      },
      {
        "show": "90 Day: Hunt for Love",
        "season": 1
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-meet-the-90-day-singles",
    "relationships": [
      {
        "id": "ARC-6338A8038722",
        "displayName": "Lisa & Usman",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 4,
        "firstYear": 2020,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-lisa-hamme",
            "name": "Lisa"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 4
          }
        ]
      },
      {
        "id": "ARC-9E71243C6B93",
        "displayName": "Kim & Usman",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 5,
        "firstYear": 2021,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-kim-menzies",
            "name": "Kim"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 7
          }
        ]
      },
      {
        "id": "ARC-F26BE50716DE",
        "displayName": "Cortney & Usman",
        "firstShow": "90 Day: Hunt for Love",
        "firstSeason": 1,
        "firstYear": 2025,
        "sourceUrl": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-drama-recap",
        "partners": [
          {
            "personId": "p-cortney-reardanz",
            "name": "Cortney"
          }
        ],
        "appearances": [
          {
            "show": "90 Day: Hunt for Love",
            "season": 1
          }
        ]
      }
    ]
  },
  {
    "personId": "p-debbie-aguero",
    "name": "Debbie Aguero",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 4,
    "firstPartner": "Oussama",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 4
      },
      {
        "show": "90 Day: The Single Life",
        "season": 4
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-single-life",
    "relationships": [
      {
        "id": "ARC-113FFEEE5196",
        "displayName": "Debbie & Oussama",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 4,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-oussama-berber",
            "name": "Oussama"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 4
          }
        ]
      }
    ]
  },
  {
    "personId": "p-oussama-berber",
    "name": "Oussama Berber",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 4,
    "firstPartner": "Debbie",
    "billedFrom": "Morocco",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 4
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-the-other-way",
    "relationships": [
      {
        "id": "ARC-113FFEEE5196",
        "displayName": "Debbie & Oussama",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 4,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-debbie-aguero",
            "name": "Debbie"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 4
          }
        ]
      }
    ]
  },
  {
    "personId": "p-sarper-guven",
    "name": "Sarper Güven",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 5,
    "firstPartner": "Shekinah",
    "billedFrom": "Turkey",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6
      },
      {
        "show": "90 Day Fiancé",
        "season": 11
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/season-3-couples-bios",
    "relationships": [
      {
        "id": "ARC-C3B0950D3D10",
        "displayName": "Shekinah & Sarper",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 5,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-shekinah-garner",
            "name": "Shekinah"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 11
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 6
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-shekinah-garner",
    "name": "Shekinah Garner",
    "firstShow": "90 Day Fiancé: The Other Way",
    "firstSeason": 5,
    "firstPartner": "Sarper",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 5
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6
      },
      {
        "show": "90 Day Fiancé",
        "season": 11
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 3
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/season-3-couples-bios",
    "relationships": [
      {
        "id": "ARC-C3B0950D3D10",
        "displayName": "Shekinah & Sarper",
        "firstShow": "90 Day Fiancé: The Other Way",
        "firstSeason": 5,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-sarper-guven",
            "name": "Sarper"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 11
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 5
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 6
          },
          {
            "show": "90 Day: The Last Resort",
            "season": 3
          }
        ]
      }
    ]
  },
  {
    "personId": "p-ashley-michelle",
    "name": "Ashley Michelle",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Manuel",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-31293D10099D",
        "displayName": "Ashley & Manuel",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-manuel-ashley-arc",
            "name": "Manuel"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 8
          }
        ]
      }
    ]
  },
  {
    "personId": "p-manuel-ashley-arc",
    "name": "Manuel Vélez Rojas",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Ashley",
    "billedFrom": "Ecuador",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-31293D10099D",
        "displayName": "Ashley & Manuel",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-ashley-michelle",
            "name": "Ashley"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 8
          }
        ]
      }
    ]
  },
  {
    "personId": "p-clayton-clark",
    "name": "Clayton Clark",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Analí",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-20FA728244CD",
        "displayName": "Clayton & Anali",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-anali-vallejos",
            "name": "Anali"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-anali-vallejos",
    "name": "Analí Vallejos",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Clayton",
    "billedFrom": "Peru",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-20FA728244CD",
        "displayName": "Clayton & Anali",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-clayton-clark",
            "name": "Clayton"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-sam-wilson",
    "name": "Sam Wilson",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Citra",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-644B553512B2",
        "displayName": "Sam & Citra",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-citra-sam-arc",
            "name": "Citra"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-citra-sam-arc",
    "name": "Citra",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Sam",
    "billedFrom": "Indonesia",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-644B553512B2",
        "displayName": "Sam & Citra",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-sam-wilson",
            "name": "Sam"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-devin-hoofman",
    "name": "Devin Hoofman",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Nick",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-DBA99C187C1E",
        "displayName": "Devin & Nick",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-seungdo-nick-ham",
            "name": "Nick"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-seungdo-nick-ham",
    "name": "Seungdo “Nick” Ham",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Devin",
    "billedFrom": "South Korea",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-DBA99C187C1E",
        "displayName": "Devin & Nick",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-devin-hoofman",
            "name": "Devin"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-nikki-sanders",
    "name": "Nikki Sanders",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Justin",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-F65643E1A04D",
        "displayName": "Justin & Nikki",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-igor-justin-shutencov",
            "name": "Justin"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-igor-justin-shutencov",
    "name": "Igor \"Justin\" Shutencov",
    "firstShow": "90 Day Fiancé",
    "firstSeason": 10,
    "firstPartner": "Nikki",
    "billedFrom": "Moldova",
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 10
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance",
    "relationships": [
      {
        "id": "ARC-F65643E1A04D",
        "displayName": "Justin & Nikki",
        "firstShow": "90 Day Fiancé",
        "firstSeason": 10,
        "firstYear": 2023,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-nikki-sanders",
            "name": "Nikki"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé",
            "season": 10
          }
        ]
      }
    ]
  },
  {
    "personId": "p-tigerlily-taylor",
    "name": "Tigerlily Taylor",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Adnan",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 9
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-FD027E1390E4",
        "displayName": "Tigerlily & Adnan",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-adnan-abdelfattah",
            "name": "Adnan"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 9
          }
        ]
      }
    ]
  },
  {
    "personId": "p-adnan-abdelfattah",
    "name": "Adnan Abdelfattah",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Tigerlily",
    "billedFrom": "Jordan",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 9
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-FD027E1390E4",
        "displayName": "Tigerlily & Adnan",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-tigerlily-taylor",
            "name": "Tigerlily"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: Happily Ever After?",
            "season": 9
          }
        ]
      }
    ]
  },
  {
    "personId": "p-niles-valentine",
    "name": "Niles Valentine",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Matilda",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 8
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-6C37F116667F",
        "displayName": "Niles & Matilda",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-matilda-nti",
            "name": "Matilda"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 8
          }
        ]
      }
    ]
  },
  {
    "personId": "p-matilda-nti",
    "name": "Matilda Nti",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Niles",
    "billedFrom": "Ghana",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 8
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-6C37F116667F",
        "displayName": "Niles & Matilda",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-niles-valentine",
            "name": "Niles"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          },
          {
            "show": "90 Day Fiancé: The Other Way",
            "season": 8
          }
        ]
      }
    ]
  },
  {
    "personId": "p-faith-gatoc-tulod",
    "name": "Faith Gatoc Tulod",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Loren",
    "billedFrom": "Philippines",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-CFFD85BCDF44",
        "displayName": "Loren & Faith",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-loren-allen",
            "name": "Loren"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          }
        ]
      }
    ]
  },
  {
    "personId": "p-loren-allen",
    "name": "Loren Allen",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Faith",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-CFFD85BCDF44",
        "displayName": "Loren & Faith",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-faith-gatoc-tulod",
            "name": "Faith"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          }
        ]
      }
    ]
  },
  {
    "personId": "p-veah-netherton",
    "name": "Veah Netherton",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Sunny",
    "billedFrom": "United States",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-604808717491",
        "displayName": "Veah & Sunny",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-sunny-mahdi",
            "name": "Sunny"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          }
        ]
      }
    ]
  },
  {
    "personId": "p-sunny-mahdi",
    "name": "Sunny Mahdi",
    "firstShow": "90 Day Fiancé: Before the 90 Days",
    "firstSeason": 7,
    "firstPartner": "Veah",
    "billedFrom": "South Africa",
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 7
      }
    ],
    "sourceUrl": "https://www.tlc.com/shows/90-day-fiance-before-the-90-days/photo-galleries/90-day-fiance-before-the-90-days-couples-season-7",
    "relationships": [
      {
        "id": "ARC-604808717491",
        "displayName": "Veah & Sunny",
        "firstShow": "90 Day Fiancé: Before the 90 Days",
        "firstSeason": 7,
        "firstYear": 2024,
        "sourceUrl": "https://90dayblog.com/the-complete-90-day-fiance-cast-list-by-season-franchise/",
        "partners": [
          {
            "personId": "p-veah-netherton",
            "name": "Veah"
          }
        ],
        "appearances": [
          {
            "show": "90 Day Fiancé: Before the 90 Days",
            "season": 7
          }
        ]
      }
    ]
  }
] satisfies Batch50Seed[]
